import { observe } from "jotai-effect";
import { ToastManager } from "utilities/toast/toast-manager";
import {
    BookviewConversationAtom,
    ModalConversationAtom,
} from "./current-conversation/conversation-atoms";
import { ConversationHistoryAtom } from "./conversation-history/conversation-history-atom";

export function conversationsAtomErrorsEffect() {
    return observe((get, set) => {
        const { error: modalError } = get(ModalConversationAtom);
        const { error: bookviewError } = get(BookviewConversationAtom);
        const { error: historyError } = get(ConversationHistoryAtom);
        if (modalError) {
            console.error("ModalConversationAtom error:", modalError);
            ToastManager.error(modalError.message);

            set(ModalConversationAtom, (dispatch) => {
                dispatch({ type: "RESET_ERROR" });
            });
        }
        if (bookviewError) {
            console.error("BookviewConversationAtom error:", bookviewError);
            ToastManager.error(bookviewError.message);

            set(BookviewConversationAtom, (dispatch) => {
                dispatch({ type: "RESET_ERROR" });
            });
        }
        if (historyError) {
            console.error("ConversationHistoryAtom error:", historyError);
            ToastManager.error(historyError.message);

            set(ConversationHistoryAtom, (dispatch) => {
                dispatch({ type: "RESET_ERROR" });
            });
        }
    });
}
